import { apiClient } from '../client';
import { ProductVariationMap } from '../../../contract/dtos/product';

export const getProductVariationMap = async (productId: string, tenantId: string, branchId: string, componentId: string): Promise<ProductVariationMap[]> => {
  const response = await apiClient.get(`corporate/v1/tenant-products/${productId}/variation-maps?tenant_id=${tenantId}&branch_id=${branchId}&customer_view=true&component_id=${componentId}`);
  return response.data;
};
